import { Typography } from "@mui/material";
import type {
  CustomContentProps,
  OptionsObject,
  VariantOverrides,
} from "notistack";
import { forwardRef } from "react";

import { Column } from "../layout";

import * as sx from "./index.sx";

export const StructuredContent = forwardRef<
  HTMLDivElement,
  CustomContentProps & VariantOverrides["structured"]
>(function StructuredContent({ body, icon, title, ...rest }, ref) {
  return (
    <sx.StyledContent
      {...rest}
      ref={ref}
      iconVariant={{ [rest.variant]: icon }}
      message={
        <Column>
          {typeof title === "string" ? (
            <Typography variant="subtitle1">{title}</Typography>
          ) : (
            title
          )}
          {typeof body === "string" ? (
            <Typography variant="body2">{body}</Typography>
          ) : (
            body
          )}
        </Column>
      }
    />
  );
});

export const getStructuredSnackbarOptions = (
  options: Omit<Partial<OptionsObject>, "variant"> &
    VariantOverrides["structured"],
) =>
  ({
    preventDuplicate: true,
    ...options,
    variant: "structured",
  }) as const;
